import { callApi } from './api';

import { DetailedAttendanceReservation } from '@/types/attendanceReservation';

export const updateReservationPeriod = async (
  resID: number,
  startTime: string,
  endTime: string
) => {
  const { status, result } = await callApi<DetailedAttendanceReservation>(
    `attendance-reservations/${resID}/period`,
    'PATCH',
    undefined,
    { start_time: startTime, end_time: endTime },
    undefined,
    undefined,
    true
  );
  return { status, result };
};
